import React  from "react";
import "./ManageCard.scss";
import EditIcon from "../../assets/icons/EditIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";


const ManageCard = ({ label, status, oneditclick, ondeleteclick}) => {  

  
  return (
    <div className="manage-card">
      <div className="stage-head">
        <h3>{label}</h3>

        <div className="card-details">
        <label>Status : </label>
        <label className="card-label-bold">{status}</label>
      </div>
        <div className="action">
          <button className="btn edit" onClick={oneditclick} >
            <EditIcon />
          </button>
          <button className="btn delete" onClick={ondeleteclick}>
            <DeleteIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageCard;
